import { model as i18n } from '!/i18n'
import { model as router } from '!/router'
import { formatContinueWatching } from '$/continue-watching/lib'
import { api, MediaTypes, VideoType } from '@setplex/tria-api'
import { combine, createEvent, createStore, sample, type Store } from 'effector'
import { T } from '~/shared/helpers'
import type {
  IContinueWatchingCardFormat,
  SelectContinueWatchingParams,
} from './index.h'

export const resetShownFromContinueWatchingRaw = createEvent()
export const $shownFromContinueWatchingRaw = createStore(false).reset(
  resetShownFromContinueWatchingRaw
)

export const $continueWatching: Store<IContinueWatchingCardFormat[]> = combine(
  api.continueWatching.$continueWatchingRow,
  i18n.$t,
  (content, { t }) => formatContinueWatching({ content, t })
)

export const redirectToPlayer = createEvent<SelectContinueWatchingParams>()

sample({
  clock: redirectToPlayer,
  fn: ({ contentId, contentType, tvShowId, seasonId, withSeason }) => {
    const params = new URLSearchParams()

    const videoType =
      contentType === MediaTypes.VOD ? VideoType.VOD : VideoType.SHOW

    if (videoType === VideoType.VOD) params.set('vodId', String(contentId))

    if (tvShowId) params.set('tvshowId', String(tvShowId))

    if (seasonId && withSeason) params.set('seasonId', String(seasonId))

    if (videoType === VideoType.SHOW) params.set('episodeId', String(contentId))

    params.set('categoryId', '0')

    // TODO: think about way to get routes from router, instead of manually construct url
    return `/player/${videoType.toLowerCase()}?${params}`
  },
  target: router.navigatePush,
})

sample({
  clock: redirectToPlayer,
  fn: T,
  target: $shownFromContinueWatchingRaw,
})
